import { useCallback } from "react";

import {
  type OverrideRunProps,
  useRequestWithFeedback,
} from "../../../composites";
import { useObjectMemo } from "../../../hooks";

import { API } from "./api";

import type { OrganizationUsersPayload } from "../../../../types/models/v1";

export const useFetchOrganizationUsers = (orgId: API.OrganizationId) => {
  const { send, loading, status } =
    useRequestWithFeedback<OrganizationUsersPayload>();

  const fetchOrganizationUsers = useCallback(
    (overrideRunProps: OverrideRunProps) => {
      send({
        action: API.fetchOrganizationUsers(orgId),
        ...overrideRunProps,
      });
    },
    [send, orgId],
  );

  return useObjectMemo({
    error: status === "error",
    send: fetchOrganizationUsers,
    loading,
  });
};
